// @flow

import React from 'react';

import './SelectedItemsList.module.scss';

const DeselectIcon = () => <div styleName="deselect" className="icon icn-icon-white-close" />;

const SelectedItemsList = ({id, uiName, onRemoveItem}: any) => (
  <div styleName="panel">
    <span className="ellipsis">{uiName}</span>
    <button
      type="button"
      className="btn btn-flat btn-icon btn-blue-light"
      onClick={() => setTimeout(() => onRemoveItem(id), 0)}
    >
      <DeselectIcon />
    </button>
  </div>
);

export default SelectedItemsList;
